import React from "react";

const SocialCard = ({ url, Icon, customStyle }) => {
  const iconClass = customStyle ? customStyle : "";
  return (
    <React.Fragment>
      <a href={url} rel="noopener noreferrer" target="blank">
        <Icon className={iconClass} />
      </a>
    </React.Fragment>
  );
};

export default SocialCard;
